module.exports = __webpack_public_path__ + "static/media/buy0.ead30c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/buy/buy0.png
// module id = 1089
// module chunks = 0